export default defineNuxtRouteMiddleware(({ path, query, hash }) => {
    // Add trailing slash ONLY for base route (/en_INT, /de_AT, /sv_SE, ...)
    if (path.length <= 7 && !path.endsWith('/')) {
        const trailingRoute = { path: `${path}/`, query, hash };
        // 301 Permanent Redirect for language base routes
        return navigateTo(trailingRoute, { redirectCode: 301 });
    }
});
